import { render, staticRenderFns } from "./BudgetPerformance.vue?vue&type=template&id=628f3268&scoped=true&"
import script from "./BudgetPerformance.vue?vue&type=script&lang=js&"
export * from "./BudgetPerformance.vue?vue&type=script&lang=js&"
import style0 from "./BudgetPerformance.vue?vue&type=style&index=0&id=628f3268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f3268",
  null
  
)

export default component.exports